import { ApplicationConfig, inject, provideBrowserGlobalErrorListeners, provideEnvironmentInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideToastr } from 'ngx-toastr';
import { provideNativeDateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeEs);
import { IconsService } from './core/services/icons-service';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { appInterceptor } from './core/interceptor/app.interceptor';
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideToastr({
      // maxOpened: 1,
      timeOut: 5000,
      extendedTimeOut: 1000,
      progressBar: true,
      closeButton: true,
      disableTimeOut: false,
      tapToDismiss: false,
      preventDuplicates: true,
      countDuplicates: true
    }),
    provideAnimationsAsync(),
    { provide: MAT_DATE_LOCALE, useValue: 'es-PE' },
    provideEnvironmentInitializer(() => {
      inject(IconsService);
    }),
    provideHttpClient(withInterceptors([appInterceptor])),

  ]
};
